module.exports = __webpack_public_path__ + "e2e466f552c6d5f0bb383f01fcb496ce.png";